import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Breadcrumb from "@/components/Breadcrumb";
import ArticleCard from "@/components/ArticleCard";
import SchemaMarkup from "@/components/SchemaMarkup";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import { testimonials } from "@/mocks/testimonials";
import { useState } from "react";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [testimonialIdx, setTestimonialIdx] = useState(0);

  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);
  const hotInCategory = categoryArticles.filter((a) => a.isHot);
  const remainingArticles = categoryArticles.filter((a) => !a.isHot);

  const catName = category?.name || "分类";
  const catDesc =
    category?.description ||
    "浏览91EatGossip各类娱乐八卦爆料，第一时间掌握明星丑闻、网红翻车、综艺内幕等独家资讯。";

  return (
    <>
      <SchemaMarkup
        type="WebPage"
        data={{
          name: `${catName} - 91EatGossip`,
          description: catDesc,
          url: `http://msldyun.cn/category/${slug}`,
        }}
      />
      <SchemaMarkup
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: "http://msldyun.cn/" },
            { "@type": "ListItem", position: 2, name: catName, item: `http://msldyun.cn/category/${slug}` },
          ],
        }}
      />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-20">
          <section className="relative min-h-[400px] md:min-h-[500px] flex items-center">
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 min-h-[400px] md:min-h-[500px]">
              <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-0 order-2 lg:order-1 bg-background-50">
                <div className="max-w-xl">
                  <Breadcrumb
                    items={[{ label: "首页", path: "/" }, { label: catName }]}
                  />
                  <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mt-6 mb-4">
                    {catName}
                  </h1>
                  <p className="text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
                    {catDesc}
                  </p>
                  <div className="flex items-center gap-4 text-sm text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-file-list-3-line" />
                      {categoryArticles.length} 篇爆料
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line" />
                      {hotInCategory.length} 条热门
                    </span>
                  </div>
                </div>
              </div>
              <div className="relative order-1 lg:order-2 min-h-[250px] lg:min-h-[500px]">
                <img
                  src={
                    category?.image ||
                    "https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20light%20texture%20on%20dark%20background%2C%20cinematic%20grain%20film%20photography%20style%2C%20moody%20dramatic%20atmosphere%20with%20orange%20amber%20tones%2C%20editorial%20art%20composition&width=800&height=600&seq=cat-default-01&orientation=landscape"
                  }
                  alt={catName}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-background-50/50 via-transparent to-transparent lg:block hidden" />
              </div>
            </div>
          </section>

          {hotInCategory.length > 0 && (
            <section className="bg-foreground-950 py-16 md:py-24 px-4 md:px-8 lg:px-12">
              <div className="w-full max-w-7xl mx-auto">
                <div className="flex items-center gap-3 mb-10">
                  <span className="px-3 py-1.5 border border-background-400 text-background-300 text-xs uppercase tracking-wide rounded-full">
                    本类热门
                  </span>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                    {catName} · 最热爆料
                  </h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                  {hotInCategory.slice(0, 6).map((article) => (
                    <ArticleCard key={article.id} article={article} variant="default" />
                  ))}
                </div>
              </div>
            </section>
          )}

          <section className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
            <div className="w-full max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-10">
                <span className="px-3 py-1.5 border border-background-300 text-foreground-600 text-xs uppercase tracking-wide rounded-full">
                  全部文章
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  {catName} · 最新更新
                </h2>
              </div>

              {remainingArticles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                  {remainingArticles.map((article) => (
                    <ArticleCard key={article.id} article={article} variant="default" />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <p className="text-foreground-500">该分类暂无更多文章</p>
                </div>
              )}
            </div>
          </section>

          <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
            <div className="w-full max-w-3xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10">
                （读者评价）
              </h2>
              <div className="text-left">
                <div className="flex items-center gap-2 mb-6">
                  <div className="px-3 py-1.5 bg-foreground-900 text-background-50 rounded-full text-xs font-medium flex items-center gap-1.5">
                    <i className="ri-star-fill text-accent-500" />
                    <span>{testimonials[testimonialIdx].rating}</span>
                  </div>
                </div>
                <blockquote className="font-heading text-lg text-foreground-800 leading-relaxed mb-8">
                  &ldquo;{testimonials[testimonialIdx].quote}&rdquo;
                </blockquote>
                <div className="flex items-center gap-3">
                  <img
                    src={testimonials[testimonialIdx].avatar}
                    alt={testimonials[testimonialIdx].author}
                    className="w-12 h-12 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {testimonials[testimonialIdx].author}
                    </p>
                    <p className="text-xs text-foreground-500">
                      {testimonials[testimonialIdx].role}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-end gap-2 mt-8">
                <button
                  onClick={() =>
                    setTestimonialIdx((i) => (i === 0 ? testimonials.length - 1 : i - 1))
                  }
                  className="w-10 h-10 border border-foreground-300 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-line" />
                </button>
                <button
                  onClick={() =>
                    setTestimonialIdx((i) => (i === testimonials.length - 1 ? 0 : i + 1))
                  }
                  className="w-10 h-10 bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}